export function dataLayerQueryParams({pageData}) {
  const filteredPageData = {}
  KEYWORDS.forEach(key => {
    if (pageData[key]) {
      filteredPageData[key] = pageData[key]
    }
  })
  const urlAddendum = Object.keys(filteredPageData)
    .map(key => `${key}=${encodeURI(filteredPageData[key])}`)
    .join('&')
  return urlAddendum
}

const KEYWORDS = [
  'ad_publisher_type_id',
  'brand',
  'brand_id',
  'car_body',
  'city',
  'fuel',
  'km',
  'model',
  'model_id',
  'mts2',
  'power',
  'price',
  'property_id',
  'property_state_id',
  'property_sub_id',
  'region_level2',
  'rooms',
  'transaction_id',
  'transmission_id',
  'urlp',
  'version',
  'year'
]
